import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
// import classNames from 'classnames';
import messages from './studentSimulatedMessages';
import './SimulatedCard.scss';

function SimulatedCard(props) {
  const { formatMessage } = props.intl;
  return (
    <div className="card card-school simulated-card" style={props.style}>
      <div className="card-body">
        <div className="card-id">ID: {props.idString}</div>
        {/* <div className="fixed-actions">
          <button className="edit-card" onClick={props.onClick}>
            <i className="ti-pencil-alt" />
            {formatMessage(messages.edit)}
          </button>
        </div> */}
        <h5 className="card-title my-0 mt-5 mb-2" style={{ color: '#F59F8D' }}>
          <span>{props.applicationName}</span>
          <span> {props.applicationDisciplines}</span>
        </h5>
        <p className="mb-2">
          {props.segment} - {props.level}
        </p>
        <p className="mb-2">{props.evaluationDisciplines}</p>
        {props.date && (
          <p>
            {formatMessage(messages.date)}: {moment(props.date).format('DD/MM/YYYY')}
          </p>
        )}
        <p className="mb-4" />
        <div className="mt-5 mb-3">
          {
            props.attempts && props.attempts.length && (
              <button
                className="btn btn-sm btn-success"
                style={{ bottom: '40px' }}
                onClick={props.onClick}
                type="button"
              >
                {formatMessage(messages.viewReport)}
              </button>
            )
            // : (
            //   <button className="btn btn-sm btn-gray" style={{ bottom: '40px' }} onClick="#">
            //     {formatMessage(messages.answer)}
            //   </button>
            // )
          }
        </div>
      </div>
    </div>
  );
}

SimulatedCard.propTypes = {
  id: PropTypes.string,
  onClick: PropTypes.func,
  iconClassName: PropTypes.string,
  title: PropTypes.string,
  period: PropTypes.string,
  date: PropTypes.oneOf(PropTypes.string, PropTypes.date),
  amountStudents: PropTypes.number,
  amountCards: PropTypes.number,
  badge: PropTypes.node,
  intl: PropTypes.object,
};

SimulatedCard.defaultProps = {
  iconClassName: 'pe-7s-light',
  dateStatus: {},
};

export default injectIntl(SimulatedCard);
